import ModelManagementForm from './ModelManagement-comp';

const ModelManagement = () => {
  return <ModelManagementForm />;
};

export default ModelManagement;